import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as BeamlineShutterActions from './beamline-shutter.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';

@Injectable({
  providedIn: 'root'
})
export class BeamlineShutterStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }
  initStore() {
    this.store.dispatch(new BeamlineShutterActions.BeamlineShutterRefresh());
  }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.BEAMLINE_SHUTTER, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new BeamlineShutterActions.BeamlineShutterCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new BeamlineShutterActions.BeamlineShutterUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new BeamlineShutterActions.BeamlineShutterDelete(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new BeamlineShutterActions.BeamlineShutterRefresh());
          break;

        case SignalRAction.RequestRefresh:
          this.store.dispatch(new BeamlineShutterActions.BeamlineShutterRefresh());
          break;
      }
    });
  }
}
